import { Link } from 'gatsby';
import { EuiSpacer, EuiButton } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Multimedia/Image/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/MultimediaPerm';
import UpdateBox from 'components/Web_User_Interface/1440p_Series/Multimedia/Image/PrimaryBoxUpdates';
import ImageTable from 'components/Web_User_Interface/1440p_Series/Multimedia/Image/imageTable';
import WDRGallery from 'components/Web_User_Interface/1440p_Series/Multimedia/Image/WDRGallery';
import ImageAdvancedTable from 'components/Web_User_Interface/1440p_Series/Multimedia/Image/imageAdvancedTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  EuiButton,
  SuccessBox,
  PermissionBox,
  UpdateBox,
  ImageTable,
  WDRGallery,
  ImageAdvancedTable,
  BreadCrumbs,
  SEOHelmet,
  React
};